import React from 'react'
import { createRoot } from 'react-dom/client';
import App from './App'
import * as Sentry from '@sentry/react'

Sentry.init({
    dsn: "https://1320a9b8bd029a3d732ff23e6e29b3dd@o1087374.ingest.us.sentry.io/4508015255224320",
    integrations: [Sentry.browserTracingIntegration()],
    environment: 'production',
    tracesSampleRate: .5,
})

const container = document.getElementById('cpop-signup-app');
const root = createRoot(container);
const appType = container.id.includes('full') ? 'full' : 'compact';
root.render(<App />);
